module.exports = __webpack_public_path__ + "static/media/matt.cc68fbd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/thumbnails/matt.jpg
// module id = 985
// module chunks = 0